import {
    LocalPolice,
    PriceCheck,
    Unpublished,
    Verified,
} from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../assets/utils/colors";
import useCurrency from "../../hooks/useCurrency";

const MemberShipLevelWidget3 = ({ level }) => {
    const currency = useCurrency();

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    borderRadius: 5,
                    p: 4,
                    position: "relative",
                    border: `1px solid ${colors.primary}`,
                    background: `linear-gradient(360deg, ${colors.bgColor1}, ${colors.bgColor1})`,
                }}
            >
                <Box
                    sx={{
                        height: 60,
                        width: 60,
                        bgcolor: "red",
                        position: "absolute",
                        top: 5,
                        right: 5,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: 4,
                        background: `linear-gradient(180deg, ${colors.bgColor4}, ${colors.bgColor4})`,
                    }}
                >
                    <LocalPolice
                        sx={{
                            fontSize: 35,
                            color:
                                level.levelName === "Platinum"
                                    ? "gray"
                                        ? colors.secondary
                                        : level.levelName === "Silver"
                                    : colors.orange,
                        }}
                    />
                </Box>
                <Grid container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <Typography
                            sx={{
                                fontSize: 20,
                                fontWeight: "bold",
                                background: `linear-gradient(rgba(23, 148, 202, .8), rgb(49, 180, 76, .8))`,
                                backgroundClip: "text",
                                textFillColor: "transparent",
                            }}
                        >
                            {level.levelName}
                        </Typography>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                fontWeight: "bold",
                                border: `1px solid ${colors.primary}`,
                                px: 2,
                                py: 0.6,
                                borderRadius: 2,
                                color: colors.primary,
                            }}
                        >
                            <PriceCheck sx={{ mr: 1.5 }} />
                            {currency.formatCurrency("TZS", level.levelFee)}
                        </Typography>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Typography
                            sx={{
                                fontSize: 14,
                                textAlign: "center",
                                p: 1,
                                fontWeight: "bold",
                                opacity: 0.8,
                            }}
                        >
                            Service / Benefit
                        </Typography>
                        <Box sx={{ height: "20vh", overflow: "auto" }}>
                            {level?.benefits.map((benefit, index) => (
                                <Box
                                    sx={{
                                        fontSize: 14,
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 1,
                                        justifyContent: "space-between",
                                    }}
                                    key={index}
                                >
                                    <Box>
                                        <Typography
                                            component={"span"}
                                            noWrap
                                            sx={{
                                                fontSize: 12,
                                                mr: 1,
                                            }}
                                        >
                                            <strong>{`${++index} )`}</strong>
                                        </Typography>
                                        <Typography
                                            component={"span"}
                                            sx={{
                                                fontSize: 12,
                                            }}
                                        >
                                            {benefit.service}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ pr: 1 }}>
                                        {benefit.status ? (
                                            <>
                                                <Verified
                                                    sx={{
                                                        color: colors.secondary,
                                                        fontSize: 18,
                                                    }}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <Unpublished
                                                    sx={{
                                                        color: colors.red,
                                                        fontSize: 18,
                                                    }}
                                                />
                                            </>
                                        )}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default MemberShipLevelWidget3;
